<template>
  <div>
    <component v-bind:is="currentView" v-bind="$attrs" :taskVersion="taskVersion" v-on="$listeners" ></component>
  </div>
</template>

<script>
// 暂时没想到好的办法，先用Dot的缩写D来替代.
import V0D0 from './version/v0.0/index.vue';
import V1D0 from './version/v1.0/index.vue';
import V1D1 from './version/v1.1/index.vue';

export default {
  name: 'YxtbizNewUlcdCom',
  components: {
    V0D0,
    V1D0,
    V1D1
  },
  props: {
    taskVersion: {
      type: String,
      default: '0.0'
    }
  },
  data() {
    return {
      currentView: 'V0D0'
    };
  },
  watch: {
    taskVersion: {
      handler(nval, oval) {
        console.log(this.$options.components);
        if (nval) {
          let cName = nval.indexOf('v') === 0 ? nval : `v${nval}`;
          cName = cName.toUpperCase().replace(/[.]/ig, 'D');
          const { components } = this.$options;
          if (components[cName]) { this.currentView = cName; } else {
            this.currentView = 'V0D0';
          }
        }
      },
      immediate: true
    }
  }
};
</script>
